var React = require('react');

function BtnLinkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM8 9.56223C8 10.6518 8.88288 11.5369 9.97471 11.5369C11.0631 11.5369 11.9483 10.6518 11.9483 9.56223C11.9483 8.47385 11.0631 7.58867 9.97471 7.58867C8.88403 7.58867 8 8.4727 8 9.56223ZM21.0039 23.9925H24.3885V18.0156C24.3885 15.0811 23.7548 12.8239 20.3254 12.8239C18.6779 12.8239 17.5735 13.7275 17.1211 14.584H17.0752V13.0949H13.8261V23.9925H17.2107V18.6011C17.2107 17.1798 17.4816 15.8032 19.2439 15.8032C20.981 15.8032 21.0039 17.4289 21.0039 18.693V23.9925ZM8.31555 23.9925H11.7024V13.0949H8.31555V23.9925Z","fill":"#AAAAAA"}));
}

BtnLinkedin.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = BtnLinkedin;

BtnLinkedin.default = BtnLinkedin;
